import { Button, Chip, Stack, TableCell, Typography } from '@mui/material';

export default function NotificationCell({ row, previous, sending, onSend }) {
  if (row.isTemporary) {
    return (
      <TableCell align="right">
        <Typography variant="caption" color="text.secondary">Live addons only</Typography>
      </TableCell>
    );
  }

  return (
    <TableCell align="right">
      <Stack spacing={0.75} alignItems="flex-end">
        {previous && (
          <Chip
            size="small"
            color="success"
            label={`Global · ${new Date(previous.createdAt).toLocaleString()}`}
          />
        )}
        <Button
          size="small"
          variant="contained"
          color={previous ? 'warning' : 'primary'}
          disabled={sending}
          onClick={() => onSend(row)}
        >
          {sending ? 'Sending…' : previous ? 'Send again' : 'Send notification'}
        </Button>
      </Stack>
    </TableCell>
  );
}
